(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleController', TestScheduleController);

        TestScheduleController.$inject = ['$timeout', '$scope', '$state', 'pagingParams', 'TabFleets', 'TabObjectTypes', 'paginationConstants', 'ParseLinks',
            'AlertService', 'TabActions', 'TestSchedule', 'ListObjByObjTypeAndFleet'];

        function TestScheduleController($timeout, $scope, $state, pagingParams, TabFleets, TabObjectTypes, paginationConstants, ParseLinks,
                                                AlertService, TabActions, TestSchedule, ListObjByObjTypeAndFleet) {
            var vm = this;
            vm.loadPage = loadPage;
            vm.transition = transition;
            vm.changePageSize = changePageSize;
            vm.loadTestSchedule = loadTestSchedule;
            vm.tabFleets = [];
            vm.tabObjectTypes = [];
            vm.tabObjects = [];

            vm.objPage = 0;
            vm.now = null;
            var data = new Date();
            var hours = data.getHours();
            vm.now = hours;
            vm.datelastexcution = false;

            vm.predicates = {};

            vm.currentState = "test-schedule";
            var retrievedOrder = localStorage.getItem(vm.currentState);
            if (retrievedOrder != null && retrievedOrder != "null")
                vm.predicates = JSON.parse(retrievedOrder);

            vm.selection = {fleet: -1, objectType: -1};
            vm.objParsed = 0;
            vm.testSchedule = [];

            vm.table = [];
            vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
            vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

            var allFleet = {id: -1, fleetName: "All"};
            var allObjectType = {id: -1, objectTypeName: "All"};
            vm.tabObjectTypes.push(allObjectType);

            function loadAll() {
                vm.fleet = allFleet;
                vm.objType = allObjectType;
                vm.objects = [];
                vm.page = pagingParams.page;
                loadTestSchedule();
                TabFleets.query({}, onTabFleetsSuccess, onError);
            }

            function onTabFleetsSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                if(data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        vm.tabFleets.push(data[i]);
                    }
                    if(data.length > 1){
                        vm.tabFleets.unshift(allFleet);
                    }
                    vm.fleet = vm.tabFleets[0];
                }
            }

            /* selezionata la flotta popolo la select degli object type */
            vm.selectedFleet = function (fleet) {
                if (vm.selection.fleet !== fleet.id) {
                    vm.selection.fleet = fleet.id;
                    vm.forms = [];
                    vm.currentPage = 1;
                    TabObjectTypes.byFleet({id: fleet.id}, onSuccess, onError);
                }

                function onSuccess(data) {
                    vm.fleet = fleet;
                    vm.tabObjectTypes = [];
                    for (var i = 0; i < data.length; i++) {
                        vm.tabObjectTypes.push(data[i]);
                    }
                    if(data.length !== 1){
                        vm.tabObjectTypes.unshift(allObjectType);
                    }
                    vm.objType = vm.tabObjectTypes[0];
                    vm.objects = [];
                    //reset delle due select dipendenti dalla flotta e forzatura della pagina 0 in tabella
                    transition(false);
                }
            };

            vm.selectedObjectType = function (objType) {
                if (vm.selection.objectType !== objType.id) {
                    vm.selection.objectType = objType.id;
                    vm.objType = objType;
                    vm.objects = [];
                    vm.pagesChecked = [];
                    vm.checkNextPages = false;
                    vm.forms = [];
                    vm.currentPage = 1;
                }

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            loadAll();

            vm.manageSchedule = function (testSchedule) {
                TestSchedule.manage(testSchedule, onSuccess, onError);
                function onSuccess(data) {
                    loadTestSchedule();
                }
            }
            vm.runSchedule = function (testSchedule) {
                TestSchedule.runSchedule(testSchedule, onSuccess, onError);
                function onSuccess(data) {
                    loadTestSchedule();
                }
            }


            function onTestScheduleSuccess(data, headers) {
                vm.testSchedule = data;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                transition(false);
            }

            function transition(recall) {
                //eseguo la chiamata in base alle opzioni già selezionate
                if (recall) {
                    loadTestSchedule();
                }
                $state.transitionTo($state.$current, {
                    page: vm.currentPage,
                    predicates: vm.predicates,
                    sort: sort(),
                    search: vm.charToSearch,
                    itemsPerPageChosen: vm.itemsPerPageChosen
                }, {notify: false, reload: false, location: "replace"});
            }

            function sort() {
                var sortFields = [];
                var keys = Object.keys(vm.predicates);
                for (var key in keys) {
                    var predicate = keys[key];
                    sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
                }
                localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
                return sortFields.length === 0 ? ['createdDate,desc'] : sortFields;
            }

            function loadPage (page) {
                vm.page = page;
                vm.transition();
            }

            function changePageSize() {
                if ((vm.queryCount / vm.itemsPerPageChosen) < vm.currentPage)
                    vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
                vm.forms = [];
                transition(true);
            }

            function loadTestSchedule() {
                var query = {
                    query: vm.charToSearch,
                    page: vm.page -1,
                    size: vm.itemsPerPageChosen,
                    sort: sort()};

                if (vm.objects.length === 0) {
                    if (vm.fleet.id === -1 && vm.objType.id === -1) {
                        TestSchedule.query(query, onTestScheduleSuccess, onError);
                    } else {
                        query.typeId = vm.objType.id;
                        query.fleetId = vm.fleet.id;
                        TestSchedule.byObjTypeAndFleet(query, onTestScheduleSuccess, onError);
                    }
                } else {
                    TestSchedule.byObjects(query, vm.objects, onTestScheduleSuccess, onError);
                }
            }



            vm.loadObjSelect = function (objPage) {
                if (objPage < vm.linksObj['last'] || objPage === vm.linksObj['next']) {
                    vm.objPage = objPage;
                    vm.loadObjects();
                }
            }

            vm.loadObjects = function () {
                ListObjByObjTypeAndFleet.query({
                    typeId: vm.objType.id,
                    fleetId: vm.fleet.id,
                    page: vm.objPage,
                    size: 20,
                    query: vm.charToSearch
                }, onSuccess, onError);

                function onSuccess(data, headers) {
                    vm.linksObj = ParseLinks.parse(headers('link'));
                    vm.totalItemsObj = headers('X-Total-Count');
                    for (var i = 0; i < data.length; i++) {
                        vm.tabObjects.push(data[i]);
                    }
                }
            };

            vm.selectSearch = function (searchText) {
                vm.charToSearch = searchText;
                vm.objPage = 0;
                vm.tabObjects = [];
                vm.loadObjects();
            };

            vm.search = function () {
                pagingParams.page = 1;
                loadTestSchedule();
            }
            vm.changevisibilty = function (testSchedule){
                var currDate = new Date();
                var lastexecdate = new Date(testSchedule.lastExecution)
                var millisecondscurr = currDate.getTime();
                var millisecondlastexec = lastexecdate.getTime();
                if(Math.abs(millisecondscurr - millisecondlastexec) >= 3600000){
                    vm.datelastexcution = true;
                }
                else{
                    vm.datelastexcution = false;
                }
            }


        }
    }
)
();
